function getGlobalTextCSS() {
  return {
    '.line-clamp-1': {
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: 1,
      overflow: 'hidden',
      display: '-webkit-box',
    },
    '.line-clamp-2': {
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: 2,
      overflow: 'hidden',
      display: '-webkit-box',
    },
  }
}

export default getGlobalTextCSS
